export const homeObjOne = {
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Aviation Wx',
    headline: 'Instant Weather Data',
    description:
      'All weather condition data needed for aviation in one place',
    buttonLabel: 'Depesze',
    buttonStyle: 'btn--outline',
    imgStart: '',
    img: 'images/moon.png',
    alt: 'Wx Data'
  };
